import React, { useEffect, useMemo, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import globalLectureBuilderStore from '../../../../stores/global-lecture-builder-store';
import { observer } from 'mobx-react-lite';
import TabBar from '../../../../component/tab-bar/tab-bar';
import { LectureTabDialogDetails } from './tabs/lecture-tab-dialog-details';
import globalProgramStore from '../../../../stores/program-store';
import { loadLectureDetailsOperation } from './operations/load-lecture-details-operation';
import globalCourseStore from '../../../../stores/global-course-store';
import { LectureDetails } from '../../../../api/types/lecturers/details/lecture-details';
import { LecturePageAttendance } from './tabs/attendance/lecture-page-attendance';
import { AttendanceType } from '../../../../api/types/lecturers/attendance/attendance-type';
import { SelectedSlotsState } from '../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../../calendar/tabs/serial/create-lecture-serial-tab';
import { updateLectureSchedulesOperations } from './operations/update-lecture-schedules-operations';
import { LecturePageDialogHeader } from './components/lecture-page-dialog-header';

// TODO devide into files (for the pie chart)
export interface LecturePageDialogDatamodel {
  isProfessor: boolean;
}
export const LecturePageDialog: React.FC<LecturePageDialogDatamodel> = observer(
  ({ isProfessor }) => {
    const [lectureData, setLectureData] = useState<LectureDetails>();
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleHideLecturePage = () => {
      globalLectureBuilderStore.selectedLecture = null;
    };

    const tabs = isProfessor ? ['נוכחות'] : ['פרטי המפגש', 'נוכחות'];

    const pages = isProfessor
      ? [<LecturePageAttendance lectureDetails={lectureData} />]
      : [
          <LectureTabDialogDetails
            lectureDetails={lectureData}
            lectureDetailsInformation={lectureData?.lectureInformation}
          />,
          <LecturePageAttendance lectureDetails={lectureData} />,
        ];

    const programId = useMemo(() => {
      return globalProgramStore.getCurrentId();
    }, [globalProgramStore.currentId]);

    const lecture = globalLectureBuilderStore.selectedLecture;

    useEffect(() => {
      // Only load lecture details if the lecture has the expected structure
      if (!lecture?.item?.id) {
        console.warn(
          'Cannot open lecture dialog: lecture data is missing required properties',
        );
        globalLectureBuilderStore.selectedLecture = null;
        return;
      }

      const courseId: number = globalCourseStore.currentId;
      loadLectureDetailsOperation(
        programId,
        courseId,
        lecture.item.id,
        setLectureData,
      );
    }, []);

    const onApproveAddNewSchedule = async (
      selectedSlotsState: SelectedSlotsState,
      lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
      setIsLoadingCreateLectures: (loading: boolean) => any,
      onHide?: () => any,
      attendanceRequired?: boolean,
      lectureAttendanceSessionNumber?: number,
      lectureBreakMinutes?: number,
      professorRetroactiveWorkingHours?: boolean,
    ) => {
      // TODO
      console.log(
        `onApproveAddNewSchedule is called selectedSlotsState: ${JSON.stringify(selectedSlotsState)}`,
      );
      const programId = globalProgramStore.getCurrentId();
      const courseId = globalCourseStore.getCurrentCourse()?.metadata?.id;
      await updateLectureSchedulesOperations(
        programId,
        courseId,
        lecture?.item?.id,
        lecture?.schedule.id,
        selectedSlotsState,
        handleHideLecturePage,
        professorRetroactiveWorkingHours ?? false,
      );
      // TODO operation
    };

    // Don't render dialog if lecture doesn't have the expected structure
    if (!lecture?.item?.id || !lecture?.schedule || !lecture?.class) {
      return null;
    }

    return (
      <Dialog
        header={() => (
          <LecturePageDialogHeader
            lectureData={lectureData}
            lecture={lecture}
            programId={programId}
            onApproveAddNewSchedule={onApproveAddNewSchedule}
            setLectureData={setLectureData}
          />
        )}
        showHeader={true}
        visible={!!globalLectureBuilderStore.selectedLecture}
        style={{
          height: '90vh',

          minWidth: '1100px',
          paddingTop: '16px',
          borderRadius: '8px',
          backgroundColor: '#f0f8ff',
        }}
        headerStyle={{ backgroundColor: '#f0f8ff' }}
        onHide={handleHideLecturePage}
      >
        <div style={{ marginTop: '8px' }} />

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            setSelectedIndex(index);
          }}
        ></TabBar>
        {pages[selectedIndex]}
      </Dialog>
    );
  },
);
